export default "__VITE_ASSET__DcqhhuBe__"